import { render, staticRenderFns } from "./WarehousesTransfer.vue?vue&type=template&id=36d82824&"
import script from "./WarehousesTransfer.vue?vue&type=script&lang=js&"
export * from "./WarehousesTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports